<template>

  <main ref="bookingCancel" class="l-main l-main--header l-main--footer h-color--bg" data-color="cream">

    <Header/>
    <PageIntro title="Cancel a Booking" icon="cross" font-size="30"/>

      <div v-if="(!booking && $route.params.reference)" class="">

          <Spinner />
          <hr class=""/>

      </div>

      <div v-else-if="cancelled || (booking && booking.is_cancelled===true)" class="text-center">

          <div class="pt-[20px] pb-[180px] px-[30px]">

              <h1 class="font-bold text-primary text-2xl mb-[10px]">Your booking has been cancelled</h1>
              <h2 class="text-primary text-xl mb-[10px]" v-if="booking.payments!==null">We will refund any prepaid purchases or booking deposits to your bank account in the next 7 business days. <br /><span style="font-size: 74%;line-height: 1.5;display: block;margin-top: 10px;">If you have pre-ordered a giant cookie, these cannot be refunded if cancelled within 48 hours of the time of the booking.</span></h2>
              <h2 class="font-bold">We hope to see you again soon!</h2>

          </div>

          <div class="text-center topper flex justify-between">
              <router-link class="button" :to="'/site/'+$route.params.siteId+'/pre-home'">Return to {{$store.getters.site.name}}</router-link>
              <router-link class="button" :to="'/site/'+$route.params.siteId+'/booking/calendar'">Create Another Booking</router-link>
          </div>


      </div>

      <div v-else>

                  <BookingInfo v-if="booking" :loaded-booking="booking" />

                  <hr v-if="booking"  />

                  <ValidationObserver ref="form" v-slot="{ handleSubmit }">

                      <form @submit.prevent="handleSubmit(submit)" novalidate="true">

                          <div class="form_inner table-wrap mx-[20px] md:mx-auto">

                                <label>Booking Reference<sup>*</sup></label>
                                <ValidationProvider name="Booking Reference" rules="required"  v-slot="{ errors }">
                                    <input name="reference" placeholder="A1B2C34D" v-model="form.reference" type="text" />
                                    <span class="error"  v-if="errors[0]">{{ errors[0] }}</span>
                                </ValidationProvider>

                                <label>Reason<sup>*</sup></label>
                                <ValidationProvider name="Reason" rules="required"  v-slot="{ errors }">
                                    <select v-model="form.reason_id">
                                        <option :value="null">Please select...</option>
                                        <option v-for="value in reasons" :key="value.Id" :value="value.Id">{{value.Description}}</option>
                                    </select>
                                    <span class="error"  v-if="errors[0]">{{ errors[0] }}</span>
                                </ValidationProvider>

                                <label>Comments<sup>*</sup></label>
                                <textarea v-model="form.reason"></textarea>

                                <div v-if="errorMessage" class="text-red font-bold text-center" v-html="errorMessage">

                                </div>

                          </div>

                          <div class="topper" style="display: block">

                                <div class=" flex justify-between">
                                  <a @click="goBack" class="button  px-[10px]">Back to Bookings</a>
                                  <button v-if="!requesting" type="submit" class="button  !px-[10px]">Cancel my Booking</button>
                                  <Spinner v-else :small="true"   :is-static="true"  class="inline-block" />
                                </div>

                          </div>

                        <div class="text-center py-[20px]">

                          <router-link class="font-bold  underline  text-red" :to="'/site/'+$route.params.siteId+'/home'">Return to {{($store.getters.site)?$store.getters.site.name:'Pub'}}</router-link>
                        </div>



                      </form>
                  </ValidationObserver>

      </div>




  </main>
</template>


<script>


import moment from "moment";
import axios from "axios";
import Spinner from "@/components/App/Spinner";
import BookingInfo from "@/components/Booking/BookingInfo";
import Header from "@/components/Layout/Header";
import PageIntro from "@/components/App/PageIntro";

export default {
  name: 'Guest',
  components:{
    BookingInfo,
    Spinner,
    Header,
    PageIntro
  },
  data(){
    return {
        cancelled:false,
        form:{
            reference:(this.$route.params.reference)?this.$route.params.reference:'',
            reason:null,
            reason_id:null
        },
        booking:null,
        requesting:false,
        errorMessage:null,
        reasons:[],
        reasonsError:null,
    }
  },

  mounted(){
    if(window.doLastPageScroll===true) this.$refs.bookingCancel.scrollTop = this.$store.getters.lastPagePosition[this.$route.path];
    //if(this.$route.params.siteId) this.$store.commit('setSite',this.$route.params.siteId);
    //this.getBooking();
    this.getCancelReasons();
  },
  computed: {

    bookingDate(){
          return moment(this.booking.date).format('ddd, Do MMM YYYY');
    }
  },
  methods:{
    goBack() {
      this.$store.commit('goingBack',true);
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    },
    removeSeconds(time){
          return (time+'').substring(0, (time+'').length-3);
    },
    getBooking(){

          if(!this.$route.params.bookingUuid) return;

          axios.get('/resdiary/booking/'+this.$route.params.bookingUuid,this.form).then((response)=>{
              this.booking = response.data;
              this.form.reference = this.booking.resdiary_response.Booking.Reference;
          });

    },
    getCancelReasons(){

          axios.get('/site/'+this.$route.params.siteId+'/resdiary/cancel-reasons').then((response)=>{
              if(response.data.success===true){
                  this.reasons = response.data.data;
              }else{
                  this.reasonError = true;
              }
          });

      },
      submit:function(){
          this.$refs.form.validate().then(success => {
              if (!success) { return; }

              this.requesting = true;

              axios.post('/resdiary/booking/cancel',this.form).then((response)=>{

                  if(response.data.success){
                      this.cancelled = true;
                      this.booking = response.data.response
                  }else{
                      this.requesting = false;
                      this.errorMessage = response.data.message;
                  }

              });

          });
      },
  },

}
</script>
